import type { DataGridProProps } from '@mui/x-data-grid-pro';

import type { RefuelDataGridRow } from '../../../types/RefuelDataGridRow.types';

export function createRefuelDataGridSlotProps(exportFileName: string) {
  return {
    toolbar: {
      csvOptions: {
        fileName: exportFileName,
      },
    },
    loadingOverlay: {
      variant: 'skeleton',
      noRowsVariant: 'skeleton',
    },
    noRowsOverlay: {
      id: 'no_result_label',
    },
    main: {
      'data-testid': 'refuels_table',
    },
    columnHeaders: {
      id: 'refuels_table_column_header',
    },
    footerRowCount: {
      id: 'row_count_label',
    },
    panel: {
      id: 'filter_panel',
    },
  } satisfies DataGridProProps<RefuelDataGridRow>['slotProps'];
}
